import React from "react";
import { jsx, css } from "@emotion/react";
import trelloColors from "../../../styles/trello-colors";

type TProps = {
  onClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void;
  children: string;
  className?: string;
};

function LinkLikeButton(props: TProps) {
  return (
    <div
      css={styles.linkLike}
      className={props.className}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}

export default LinkLikeButton;

const styles = {
  linkLike: css`
    text-decoration-line: underline;
    color: ${trelloColors.N300};
    cursor: pointer;
    &:hover {
      color: ${trelloColors.N800};
    }
  `,
};
